import { create } from "zustand";
import { persist } from "zustand/middleware";

interface LegislationTableFilterState {
  initializedTenants: string[];
  markInitialized: (tenantId: string) => void;
  isInitialized: (tenantId: string) => boolean;
}

const useLegislationTableFilterStore = create<LegislationTableFilterState>()(
  persist(
    (set, get) => ({
      initializedTenants: [],
      markInitialized: (tenantId: string) =>
        set((state) => {
          if (state.initializedTenants.includes(tenantId)) {
            return state;
          }
          return {
            initializedTenants: [...state.initializedTenants, tenantId],
          };
        }),
      isInitialized: (tenantId: string) =>
        get().initializedTenants.includes(tenantId),
    }),
    {
      name: "legislation-table-filter-state",
    }
  )
);

export default useLegislationTableFilterStore;
